module.exports = __webpack_public_path__ + "static/media/Elementos Web-01.004f7b23.png";